import React, { useEffect } from "react";
import { forwardRef, useState, useRef } from "react";

import { Services, olExtended } from "geoportal-extensions-openlayers";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import VectorLayer from "ol/layer/Vector";
import Map from 'ol/Map'
import View from 'ol/View'
import Overlay from "ol/Overlay";
import { get as getProjection } from "ol/proj";
import { Select, Draw } from "ol/interaction";
import "../../node_modules/geoportal-extensions-openlayers/dist/GpPluginOpenLayers.css";
import "../../node_modules/ol/ol.css";
import Feature from "ol/Feature";
import { Polygon, MultiPolygon } from "ol/geom";
import { createBox, createRegularPolygon } from "ol/interaction/Draw.js";

import axios from "axios";
//custom function
import { createInteraction, isSelectedMnx, getDalles, createDalleFeature, getDallesMnhMnt, styleDalleSelect, zoomToPolygon } from "../utils/utilsMap";
import { getIndexRemove } from "../utils/utilsList"
import { getDalleIntersectPolygon } from "../utils/polygon";
//compoenent
import MenuWrapper from "./MenuWrapper";

axios.defaults.headers = {
  "Cache-Control": "no-cache",
};

const generate_multipolygon_bloc = (drawnBlocsLayer, vectorSourceBloc) => {
  // fonction qui genere les blocs et qui est appellé à chaque fois qu'on bouge la carte, à un certain niveau de zoom
  // on fais appelle à l'api pour recuperer les blocs
  axios
    .get(process.env.REACT_APP_BLOC_URL)
    .then((response) => {
      // etant donner qu'on ne trace que les blocs dans la fenetre, à chaque fois qu'on bouge sur la carte, on remet de notre couche vierge
      drawnBlocsLayer.getSource().clear();
      // on parcours notre liste de blocs
      response.data.features.forEach((bloc) => {
        // on trace nos bblocs
        const multiPolygonFeature = new Feature({
          geometry: new MultiPolygon(bloc.geometry.coordinates),
        });
        multiPolygonFeature.setProperties({
          id: bloc.properties.name,
          superficie: bloc.properties.aire,
        });
        vectorSourceBloc.addFeature(multiPolygonFeature);
      });
    });
  return '200'
};
const styleDalle = { select: { fill: new Fill({ color: "#20bf0a", }), stroke: new Stroke({ color: "rgba(112, 119, 122)", width: 2, }), }, pointer_move_dalle_menu: { fill: new Fill({ color: "#e8f54a", }), stroke: new Stroke({ color: "black", width: 2, }), }, }



function MapLidarDerivee(props) {


  const ref = useRef(null);


  const [dalleMNXSelect, setDalleMNXSelect] = useState({ "listPolygon": [], "listDalleMnxSelect": [] });
  const [polygonSelect, setPolygonSelect] = useState([{ polygon: null, dalles: [] }])
  const [isDalleDisplay, setIsDalleDisplay] = useState(false)
  const [map, setMap] = useState(null)
  const [selectedMode, setSelectedMode] = useState({ "actifMode": "click", "oldMode": "click" })
  const [interaction, setInteraction] = useState({ "click": null, "polygon": null, "rectangle": null })


  // initialisations des couches
  const vectorSourceGridDalle = new VectorSource();
  const vectorSourceDrawPolygon = new VectorSource();
  const vectorSourceFilePolygon = new VectorSource();
  const vectorSourceBloc = new VectorSource();
  const vectorLayer = new VectorLayer({
    source: vectorSourceGridDalle,
    style: new Style({
      fill: new Fill({
        color: "rgba(0, 0, 255, 0.1)",
      }),
      stroke: new Stroke({
        color: "black",
        width: 0.5,
      }),
    }),
  });
  const drawnPolygonsLayer = new VectorLayer({
    source: vectorSourceDrawPolygon,
  });
  const filePolygonsLayer = new VectorLayer({
    source: vectorSourceFilePolygon,
  });
  const drawnBlocsLayer = new VectorLayer({
    source: vectorSourceBloc,
  });

  // initialisations des utils pour séléctions

  const drawEmprise = async (event, type) => {

    var feature = event.feature
    const id = `${type}-${feature
      .getGeometry()
      .getExtent()
      .map((point) => Math.round(point / 1000))
      .join("-")}`;
    feature.setProperties({
      id: id,
    });

    drawnPolygonsLayer.getSource().addFeature(feature);

    const dalleFeature = vectorSourceGridDalle.getFeatures()

    const dalleIntersectPolygon = await getDalleIntersectPolygon(feature.getGeometry(), id, dalleMNXSelect.listDalleMnxSelect, dalleFeature)
    dalleIntersectPolygon.forEach((dalleToAdd) => {
      dalleToAdd.dalle.setStyle(new Style(styleDalle.select));
      dalleMNXSelect.listDalleMnxSelect.push({ "id": dalleToAdd.dalle.values_.id, "mns": dalleToAdd.dalle.values_.mns, "mnh": dalleToAdd.dalleMnh, "mnt": dalleToAdd.dalleMnt, "idPolygon": id })



      setDalleMNXSelect({ ...dalleMNXSelect})

    })








  }

  const drawPolygon = new Draw({
    type: "Polygon",
  });

  drawPolygon.on("drawend", (event) => {
    drawEmprise(event, "polygon");
  });

  const drawRectangle = new Draw({
    type: "Circle",
    geometryFunction: createBox(),
  });

  drawRectangle.on("drawend", (event) => {
    drawEmprise(event, "rectangle");
  });





  useEffect(() => {

    const tempMap = new Map({
      target: ref.current,
      layers: [
        new olExtended.layer.GeoportalWMTS({
          layer: "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
        }),
        vectorLayer, // Ajout de la couche qui affichera les dalles
        drawnPolygonsLayer, // ajout de la couche qui affichera le polygon pour séléectionner des dalles
        filePolygonsLayer, // ajout de la couche qui affichera le polygon d'un fichier geojson ou shp
        drawnBlocsLayer, // ajout de la couche qui affichera les blocs
      ],
      view: new View({
        center: [669410, 6599255],
        zoom: 7,
        maxZoom: 16,
        projection: getProjection("EPSG:2154")
      }),
    });



    // Créer une couche pour afficher les informations de la dalle survolée
    var overlay = new Overlay({
      element: document.getElementById("popup"),
      autoPan: false,
      autoPanAnimation: {
        duration: 250,
      },
    });
    tempMap.addOverlay(overlay)


    let search = new olExtended.control.SearchEngine({ zoomTo: 12 });
    tempMap.addControl(search);

    // let layerSwitcher = new olExtended.control.LayerSwitcher({
    //   reverse: true,
    //   groupSelectStyle: "group",
    // });
    // tempMap.addControl(layerSwitcher);

    // const layers = document.querySelectorAll(".GPlayerSwitcher_layer");
    // layers.forEach((layer) => {
    //   if (
    //     !process.env.REACT_APP_DISPLAY_LAYER.includes(
    //       layer.firstChild.firstChild.innerHTML
    //     )
    //   ) {
    //     layer.style.display = "none";
    //   }
    // });


    let attributions = new olExtended.control.GeoportalAttribution();
    tempMap.addControl(attributions);


    // Créer une interaction de sélection pour gérer le survol des blocs
    const selectInteractionBloc = createInteraction("pointermove", drawnBlocsLayer)

    // évenement au survol d'un bloc
    selectInteractionBloc.on("select", (event) => {
      if (event.selected.length > 0) {
        const selectedFeature = event.selected[0];
        const extent = selectedFeature.values_.geometry.extent_;
        // Calcul du centre de l'extent pour afficher l'overlay par rapport au centre du bloc
        // et non par rapport au coordonnées de la souris
        const centerX = (extent[0] + extent[2]) / 2;
        const centerY = (extent[1] + extent[3]) / 2;

        // Afficher les informations du bloc dans une fenêtre contextuelle (popup)
        overlay.getElement().innerHTML = selectedFeature["values_"]["id"];
        overlay.setPosition([centerX, centerY]);
        overlay.getElement().style.display = "block";
      }
    });

    tempMap.addInteraction(selectInteractionBloc)

    //évènement au click d'un bloc
    const zoomToClickBloc = createInteraction('click', drawnBlocsLayer)

    zoomToClickBloc.on("select", (event) => {
      zoomToPolygon(event.selected[0], 11, tempMap);
      overlay.getElement().style.display = "none";
    });

    tempMap.addInteraction(zoomToClickBloc)

    tempMap.on("moveend", async () => {
      let view = tempMap.getView();
      // recupere la bbox de la fenetre de son pc
      let extent = view.calculateExtent(tempMap.getSize());


      // Efface les anciens polygones et blocs
      if (view.getZoom() >= 11) {

      vectorSourceGridDalle.clear();
      drawnBlocsLayer.getSource().clear();
        setIsDalleDisplay(true)
        // Calcule les coordonnées de la bbox
        let minX = extent[0];
        let minY = extent[1];
        let maxX = extent[2];
        let maxY = extent[3];

        const responseMNS = await getDalles(process.env.REACT_APP_DALLES_URL_MNS, minX, minY, maxX, maxY)


        let featuresList = []


        responseMNS.forEach((dalle) => {
          featuresList.push(createDalleFeature(dalle));
        });

        featuresList.forEach((dalleFeature) => {
          if (isSelectedMnx(dalleFeature.values_.id, dalleMNXSelect.listDalleMnxSelect)) {

            dalleFeature.setStyle(new Style(styleDalle.select))

          }
          vectorSourceGridDalle.addFeature(dalleFeature)
        });

      } else {


      vectorSourceGridDalle.clear();
        setIsDalleDisplay(false)
        generate_multipolygon_bloc(drawnBlocsLayer, vectorSourceBloc)
      }

    })

    // évenement au survol d'une dalle
    let survolDalleInteraction = createInteraction("pointermove", vectorLayer)
    survolDalleInteraction.on("select", (event) => {
      if (event.selected.length > 0) {
        var selectedFeature = event.selected[0];
        // quand on survole une dalle cliquer on met le style d'une dalle cliquer;
        const selected = isSelectedMnx(selectedFeature.values_.id, dalleMNXSelect.listDalleMnxSelect);
        if (selected) {
          selectedFeature.setStyle(new Style(styleDalle.select));
        }

      }
      // quand on quitte la dalle survolé
      if (event.deselected.length > 0) {
        const featureDeselect = event.deselected[0]
        const selected = isSelectedMnx(featureDeselect.values_.id, dalleMNXSelect.listDalleMnxSelect);
        if (selected) {
          featureDeselect.setStyle(new Style(styleDalle.select));
        }


      }
    });
    //ajout de l'intéraction a la carte
    tempMap.addInteraction(survolDalleInteraction)

    // intéraction click sur une dalle
    let selectInteractionDallesClick = createInteraction("click", vectorLayer)

    selectInteractionDallesClick.on("select", async (event) => {

      const dalleClick = event.selected[0]

      if (dalleClick) {
        const selected = isSelectedMnx(dalleClick.values_.id, dalleMNXSelect.listDalleMnxSelect);
        if (selected) {

          const indexRemove = getIndexRemove(dalleClick.values_.id, dalleMNXSelect.listDalleMnxSelect)
          dalleMNXSelect.listDalleMnxSelect.splice(indexRemove, 1)
          setDalleMNXSelect({ ...dalleMNXSelect})
          dalleClick.setStyle(null);

        } else {

          const [dalleMnh, dalleMnt] = await getDallesMnhMnt(dalleClick.values_.bbox)
          dalleMNXSelect.listDalleMnxSelect.push({ "id": dalleClick.values_.id, "mns": dalleClick.values_.mns, "mnh": dalleMnh, "mnt": dalleMnt, "idPolygon": null })
          dalleClick.setStyle(new Style(styleDalle.select));
          setDalleMNXSelect({ ...dalleMNXSelect })
        }

      }
      if (event.deselected.length > 0) {
        const featureDeselect = event.deselected[0];
        if (dalleMNXSelect.listDalleMnxSelect.length > 0) {

          const selected = isSelectedMnx(featureDeselect.values_.id, dalleMNXSelect.listDalleMnxSelect)

          if (selected) {
            featureDeselect.setStyle(new Style(styleDalle.select));
          } else {
            featureDeselect.setStyle(null)
          }

        } else {
          featureDeselect.setStyle(null)

        }
      }






    });

    setInteraction({ ...interaction, "click": selectInteractionDallesClick, "polygon": drawPolygon, "rectangle": drawRectangle })

    tempMap.addInteraction(selectInteractionDallesClick)

    setMap(tempMap)
  }, [])










  return (<>
    <div ref={ref} id="map"></div>
    <div id="popup" className="ol-popup">
      <div id="popup-content"></div>
    </div>
    <MenuWrapper ref={ref} dalleMNX={dalleMNXSelect.listDalleMnxSelect} isDalleDisplay={isDalleDisplay} selectedMode={selectedMode} setInteractionMode={(newMode) => {




      map.removeInteraction(interaction[selectedMode.actifMode]);
      map.addInteraction(interaction[newMode]);
      setSelectedMode({ "oldMode": selectedMode.actifMode, "actifMode": newMode })

    }}></MenuWrapper>
  </>);
}

export default MapLidarDerivee;

